import { SchedulerResourceValueObject } from '../value-objects/scheduler-resource.value-object'
import { SchedulerEventValueObject }    from '../value-objects/scheduler-event.value-object'

export class SchedulerEventValueObjectCollection {

  constructor () {
    /**
     *
     * @type {*[]}
     * @private
     */
    this._items = []
  }

  get items () {
    return this._items
  }

  /**
   *
   * @param item
   */
  push (item) {
    this._items.push(item)
  }

  /**
   *
   * @returns {[]}
   */
  toCalendarObjects (eventTypesObject = {}) {
    let output = []

    this.items.forEach((item) => {
      const event = {
        id:               item.id,
        title:            item.name,
        start:            item.beginDate,
        end:              item.endDate,
        resourceId:       item.idUserGroup + '-' + item.resourceTable,
        propResourceId:   item.idUserGroup,
        idActivity:       item.idActivity,
        entityCode:       item.entityCode,
        statusBadge:      item.statusBadge,
        statusColor:      item.statusColor,
        typeName:         item.typeName,
        typeColor:        item.typeColor,
        badge:            item.badge,
        description:      item.description,
        idtEntity:        item.idtEntity,
        editable:         !!item.entityCode,
        resourceEditable: !!item.entityCode,
      }

      if (item.color) {
        event.backgroundColor = item.color
        event.borderColor     = item.color
      }

      output.push(event)
    })

    return output
  }
}
